import Image from 'next/image'
import React from 'react'

const Logohorizontal = ({ className }: { className?: string }) => {
    return (
        <Image
            className={`${className ?? ''} w-auto h-fit`}
            src="/brand/mynawoo-logo-w.png"
            width={1068}
            height={288}
            sizes="148px"
            priority
            alt="Mynawoo"
        />
    )
}

export default Logohorizontal
